/* eslint-disable @typescript-eslint/member-ordering */
import { ConfigInfo } from '@tencent/pmd-config/lib/project';
import { getEnvUAType } from '@tencent/pmd-tools/lib/env';
import { composeUrlQuery } from '@tencent/pmd-tools/lib/url';
import { GAME_PVP, GAME_GP } from '@tencent/pmd-tools/lib/game';
import { getRainbowConfig } from '../../tools/rainbow';

class ProtocolInfo {
  private static sInstance;
  private mProtocolList: Array<any> | undefined;

  public static get instance() {
    if (!this.sInstance) {
      this.sInstance = new ProtocolInfo();
    }
    return this.sInstance;
  }

  public initProtocolInfo() {
    if (!this.mProtocolList || this.mProtocolList.length === 0) {
      getRainbowConfig({ provider_name: 'olcouponmerclist', path: 'merclist', key: '' })
        .then((response) => {
          if (response && response.r === 0) {
            this.mProtocolList = JSON.parse(response.value);
          }
        });
    }
  }

  public getUserInfoAuthorizeName() {
    return '用户信息授权协议';
  }

  public requestGetUserInfoAuthorizeProtocol(
    brandName = '', gameName = '',
    versionCode = 3071000, isNeedMore = false,
  ) {
    return async () => {
      if (!this.mProtocolList || this.mProtocolList.length === 0) {
        const response = await getRainbowConfig({ provider_name: 'olcouponmerclist', path: 'merclist', key: '' });
        if (response && response.r === 0) {
          this.mProtocolList = JSON.parse(response.value);
        }
      }
      return this.getUserInfoAuthorizeProtocol(brandName, gameName, versionCode, isNeedMore);
    };
  }

  public getUserInfoAuthorizeProtocol(
    brandName = '', gameName = '',
    versionCode = 3071000, isNeedMore = false,
  ) {
    let otherPrivacyUrl = `https://igame.qq.com/tip/ingame-page/igame-privacy/index.html#/third/share?gid=${ConfigInfo.instance.getTipGid()}`;
    if (versionCode >= 3071000) {
      otherPrivacyUrl = composeUrlQuery(otherPrivacyUrl, { versionCode });
    }

    // 这里特殊处理的原因是游戏内的页面没有返回按钮，避免跳出去，跳不回来，所以包了一层iframe
    const { isInGame } = getEnvUAType(navigator.userAgent.toLowerCase());
    if (isInGame) {
      otherPrivacyUrl = `https://igame.qq.com/tip/ingame-page/igame-privacy/index.html#/third/index?jump=${encodeURIComponent(otherPrivacyUrl)}`;
    }

    const mBrandName = brandName || '商家优惠券提供方';
    let mGameName = '';
    if (ConfigInfo.instance.getTipGid() === GAME_PVP) {
      mGameName = gameName || '王者人生';
    } else if (ConfigInfo.instance.getTipGid() === GAME_GP) {
      mGameName = gameName || '和平人生';
    } else {
      mGameName = gameName || '游戏人生';
    }
    const moreInfo = isNeedMore ? `具体请参考<a style="color: unset;" href="${otherPrivacyUrl}">《第三方合作商户清单》</a><br><br>` : '';

    let thirdInfo = '';
    if (this.mProtocolList) {
      for (const item of this.mProtocolList) {
        if (item.name === mBrandName) {
          thirdInfo = `
              <br>
              <b>与第三方共享的信息如下：</b>
              <br>功能类型：品牌优惠券发放
              <br>第三方主体：${item.company}；
              <br>使用目的：通过手机号获取来识别用户在“${item.company}”应用中的账户，将优惠券发放到品牌账户中；
              <br>处理方式：加密接口传输；
              <br>涉及个人信息类型：手机号；
              <br>第三方隐私政策或官网链接：<a style="color: unset;" href="${item.privacy}">${item.privacy}</a>
              <br>`;
          break;
        }
      }
    }

    return `《用户信息授权协议》（以下简称“本协议”）是腾讯计算机系统有限公司旗下${mGameName}平台（以下简称“${mGameName}”）与用户（以下简称“您”）所订立的有效合约。您通过网络页面点击确认或以其他方式选择接受本协议，即表示您同意接受本协议的全部约定内容。在接受本协议之前，请您仔细阅读本协议的全部内容（特别是加粗下划线标注内容）。如您不同意本协议的内容，或无法准确理解本协议任何条款的含义，请不要进行确认及后续操作。
            <br>
            <br>
            特别说明：如您不同意签署本协议意味着您不同意${mGameName}在您的授权下将您的个人信息（手机号码）提供给本协议项下发起游戏道具发放的品牌方，但是并不妨碍您正常访问相关页面；如您同意签署本协议，${mGameName}将传输您的手机号给“<b>${mBrandName}</b>“，用来为您把奖励发放到与手机号对应的“<b>${mBrandName}</b>“账户。如您同意签署本协议，${mGameName}将存储您的手机号，以便您无需或减少您手动输入个人信息。
            <br>
            <br>
            如果您对本协议有疑问的，请通过${mGameName}在线客服进行询问，其将向您解释。
            <br>
            <br>
            <b>1、您理解并同意，在您输入手机号选择领取相关奖励时，授权${mGameName}存储您的手机号码，并将您的相关个人信息（手机号码）提供至${mBrandName}（以下称：第三方），用于第三方奖励的发放。</b>
            <br>
            <br>
            2、${mGameName}通过签署协议等方式要求第三方承诺仅在授权使用范围内使用您的上述信息，并对您的信息安全储存、严格保密。
            <br>
            ${thirdInfo}
            <br>
            3、您理解，第三方提供的服务由该第三方独立运营并独立承担全部责任。因第三方所提供服务或其使用您的信息产生的纠纷，或其违反相关法律法规或本协议约定，或您在使用其服务过程中遭受的损失，请您与该第三方协商解决。
            <br>
            <br>
            4、${mGameName}对本协议进行变更或补充时，将通过手机界面弹窗的方式再次征得您的同意，并成为本协议的有效组成部分。
            <br>
            <br>
            5、双方在履行本协议的过程中，如发生争议，应协商解决。协商不成的，任何一方均可向${mGameName}所在有管辖权的人民法院提起诉讼。
            <br>
            <br>
            ${moreInfo}
`;
  }
}

export default ProtocolInfo;
